import * as stylex from '@stylexjs/stylex';

// Design tokens ported from the Flutter app theme (lib/theme.dart) — Material 3,
// light only. NOTE: StyleX requires files exporting `defineVars` to use the
// `.stylex.ts` extension so tokens resolve cross-module.
export const colors = {
  primary: "var(--xv7iowh)",
  onPrimary: "var(--xv87m8h)",
  primaryContainer: "var(--xfesq2r)",
  onPrimaryContainer: "var(--x1be8xdd)",
  secondary: "var(--x1dxtx88)",
  secondaryContainer: "var(--xui7b2t)",
  tertiary: "var(--x1xe9ess)",
  error: "var(--xm90b41)",
  text: "var(--xbyevf)",
  muted: "var(--x1r22u99)",
  border: "var(--x1m6eiej)",
  outline: "var(--x70j8lc)",
  surface: "var(--x1x523h0)",
  surfaceDim: "var(--xn8w8yr)",
  surfaceContainerLow: "var(--x1nog3cn)",
  surfaceContainer: "var(--x9sbieo)",
  surfaceContainerHigh: "var(--xoytcg3)",
  surfaceContainerHighest: "var(--xpthgpp)",
  infoBlue: "var(--x14x3plf)",
  success: "var(--x63xqvv)",
  verifiedBlue: "var(--x1jxjm0y)",
  tintCyan: "var(--x5guts6)",
  tintTertiary: "var(--x9tqe8g)",
  white: "var(--x1556qgf)",
  __themeName__: "x1392ke4"
};
export const radius = {
  sm: "var(--x8t7pks)",
  md: "var(--x1emhdao)",
  lg: "var(--xygj5xx)",
  avatar: "var(--x4yzy8g)",
  pill: "var(--xafatl4)",
  __themeName__: "xe0zml9"
};
export const shadow = {
  card: "var(--x1mzhdlo)",
  bar: "var(--x11kj3we)",
  __themeName__: "x1lttrdv"
};
export const font = {
  family: "var(--xwz68dy)",
  regular: "var(--x1jqex52)",
  medium: "var(--x1wgztwx)",
  semibold: "var(--x1jcoar0)",
  bold: "var(--x1tkakdn)",
  __themeName__: "xwlmtkj"
};

// ── Spacing / type scale (write these literal values, do not invent new ones) ──
// StyleX emits one atomic class per unique property+value. Keeping every
// component on this fixed scale — instead of ad-hoc 0.3 vs 0.325 vs 0.45 — means
// the whole app shares a handful of classes rather than one per stray value,
// which is what keeps the generated CSS small.
//
// These are literals, NOT exported tokens: the StyleX build here (esbuild-plugin
// 0.11) can't inline imported constants, and defineVars would replace short
// literals with longer `var(--…)` refs + a `:root` block (measured BIGGER). So
// the scale lives as this reference; snap new values to the nearest step.
//
//   space (padding/gap/margin): 0.125 0.25 0.375 0.5 0.625 0.75 0.875 1
//                               1.25 1.5 2 4  (rem)
//   fontSize:                   0.75 0.8125 0.9375 1 1.0625 1.25 1.5 1.75 3  (rem)
//   lineHeight:                 1.2 (tight) · 1.5 (normal)